var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0704 10.5374C16.6596 9.93888 16.987 9.13082 16.9804 8.29097C16.9738 7.45112 16.6339 6.64828 16.0354 6.05905C15.7391 5.7673 15.3881 5.53677 15.0027 5.38064C14.6173 5.2245 14.2048 5.14581 13.789 5.14906C12.9491 5.15562 12.1463 5.49555 11.5571 6.09405C11.3971 6.25405 11.1937 6.45044 10.9471 6.68322L10.2612 7.32905L9.57541 6.68322C9.32819 6.44989 9.12458 6.2535 8.96458 6.09405C8.37071 5.50019 7.56526 5.16656 6.72541 5.16656C5.88556 5.16656 5.08011 5.50019 4.48624 6.09405C3.26291 7.31822 3.24874 9.29739 4.44124 10.5274L10.2612 16.3474L16.0704 10.5374ZM3.77874 5.38739C4.16567 5.00036 4.62505 4.69335 5.13064 4.48388C5.63624 4.27442 6.17814 4.16661 6.72541 4.16661C7.27268 4.16661 7.81458 4.27442 8.32018 4.48388C8.82577 4.69335 9.28515 5.00036 9.67208 5.38739C9.82374 5.53961 10.0201 5.72905 10.2612 5.95572C10.5012 5.72905 10.6976 5.53933 10.8504 5.38655C11.6258 4.59919 12.6823 4.15212 13.7873 4.14368C14.8924 4.13524 15.9555 4.56613 16.7429 5.34155C17.5303 6.11698 17.9773 7.17343 17.9858 8.27848C17.9942 9.38354 17.5633 10.4467 16.7879 11.2341L10.8504 17.1724C10.6941 17.3286 10.4822 17.4164 10.2612 17.4164C10.0403 17.4164 9.82835 17.3286 9.67208 17.1724L3.73291 11.2332C2.97128 10.4477 2.54917 9.39416 2.55775 8.30008C2.56632 7.20599 3.00489 6.15918 3.77874 5.38572V5.38739Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeReview);
export default __webpack_public_path__ + "static/media/likeReview.ed3bc6d0b4ec9de614dbf54a3efa7190.svg";
export { ForwardRef as ReactComponent };